import { useTranslation } from 'react-i18next';

import { CardGrid } from './section';
import { SampleCards } from './sample-cards';

import css from './empty-state.module.css';

// What a list shows while it has nothing to list — every list, until the
// partner catalogs are switched on (stage 4.5 of docs/monorepo-plan.md): a
// compact "coming soon" note over the design's sample cards, which lead on to
// the other lists instead of a dead end. `exclude`: the current page's path.
export function EmptyState({ text, exclude }: { text?: string; exclude?: string }) {
  const { t } = useTranslation();

  return (
    <>
      <div className={css.note} role="status">
        <p className={css.title}>{t('empty.title')}</p>
        <p className={css.text}>{text ?? t('empty.text')}</p>
      </div>
      <CardGrid>
        <SampleCards exclude={exclude} />
      </CardGrid>
    </>
  );
}
